var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.284 1.14 3.41 3.58c.204.204.306.466.306.784 0 .295-.102.545-.307.75L8.284 9.867a1 1 0 0 1-.733.307 1 1 0 0 1-.733-.307 1.062 1.062 0 0 1-.307-.784c0-.318.103-.58.307-.784l1.637-1.704H1.057a.994.994 0 0 1-.75-.324A1.078 1.078 0 0 1 0 5.504c0-.296.102-.551.307-.767a.994.994 0 0 1 .75-.324h7.398l-1.67-1.705a1.062 1.062 0 0 1-.308-.784c0-.318.103-.58.307-.784a1.02 1.02 0 0 1 .75-.307c.296 0 .546.103.75.307z",
    fill: "#FFF",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.a8c74f3f425d3e53528f7c87fe75002e.svg";
export { ForwardRef as ReactComponent };